module.exports = __webpack_public_path__ + "static/img/soldout.2a208fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/noPicMode/soldout.svg
// module id = 2X5G
// module chunks = 1